var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"up-logo",class:{ inverse: _vm.inverse, compact: _vm.compact },attrs:{"type":"button"},on:{"click":function($event){return _vm.$emit('click')}}},[_vm._m(0),_c('span',{staticClass:"up-logo__name"},[_vm._v(_vm._s(_vm.label))])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"up-logo__mark"},[_c('img',{attrs:{"src":require("@/assets/rebuild/uplus-mark.png"),"alt":""}})])
}]

export { render, staticRenderFns }